import * as React from "react"
import { Eye, EyeOff } from "lucide-react"
import { ShadcnFormField, ShadcnFormFieldProps } from "./ShadcnFormField"
import { Button } from "@/components/ui/Button"

export interface ShadcnPasswordFieldProps extends Omit<ShadcnFormFieldProps, "type" | "rightIcon"> {
 showPasswordToggle?: boolean
}

const ShadcnPasswordField = React.forwardRef<HTMLInputElement, ShadcnPasswordFieldProps>(
 ({ showPasswordToggle = true, ...props }, ref) => {
 const [showPassword, setShowPassword] = React.useState(false)

 const togglePasswordVisibility = () => {
 setShowPassword((prev) => !prev)
 }

 return (
 <ShadcnFormField
 ref={ref}
 type={showPassword ? "text" : "password"}
 rightIcon={
 showPasswordToggle ? (
 <Button
 type="button"
 variant="ghost"
 size="icon"
 className="h-6 w-6 hover:bg-transparent"
 onClick={togglePasswordVisibility}
 aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
 >
 {showPassword ? (
 <EyeOff className="h-4 w-4 text-muted-foreground" />
 ) : (
 <Eye className="h-4 w-4 text-muted-foreground" />
 )}
 </Button>
 ) : undefined
 }
 {...props}
 />
 )
 }
)
ShadcnPasswordField.displayName = "ShadcnPasswordField"

export { ShadcnPasswordField }

